import React from "react";
import "./MoleculeStyles.scss";

export default function SectionHeading({ title, className = "" }) {
  return (
    <div className={`section_heading_block ${className}`.trim()}>
      <h3 className="section_heading_text">{title}</h3>
    </div>
  );
}
